import { useMemo } from "react";
import { BellRing, CalendarClock, Sun } from "lucide-react";
import { SENT_FILTERS } from "./SentCell";

const Tile = ({ testid, icon: Icon, n, label, hot, onClick }) => (
  <button
    data-testid={testid}
    onClick={onClick}
    disabled={!n}
    className={`group flex items-center gap-3 rounded-lg px-4 py-2.5 text-left transition-colors disabled:cursor-default ${
      hot && n ? "bg-[#FF4500] text-white hover:bg-[#E63E00]" : "bg-white/70 text-slate-700 hover:bg-white disabled:hover:bg-white/70"
    }`}
  >
    <Icon className="w-4 h-4 shrink-0" strokeWidth={1.75} />
    <span className="font-display text-2xl font-bold leading-none">{n}</span>
    <span className="text-sm leading-tight">{label}</span>
  </button>
);

export const TodayBar = ({ clubs, onPick }) => {
  const c = useMemo(() => ({
    due2: clubs.filter(SENT_FILTERS.due2).length,
    due3: clubs.filter(SENT_FILTERS.due3).length,
    soon: clubs.filter(SENT_FILTERS.soon).length,
  }), [clubs]);
  const today = new Date().toLocaleDateString("nl-NL", { weekday: "long", day: "numeric", month: "long" });
  return (
    <div data-testid="today-bar" className="mb-6 flex flex-wrap items-center gap-3 rounded-lg border border-orange-200 bg-orange-50 p-3">
      <div className="flex items-center gap-2 pr-2 text-orange-900">
        <Sun className="w-5 h-5 text-[#FF4500]" strokeWidth={1.75} />
        <div>
          <div className="font-display font-bold leading-tight">Vandaag</div>
          <div className="text-xs first-letter:uppercase text-orange-800/70">{today}</div>
        </div>
      </div>
      <Tile testid="today-due2" icon={BellRing} n={c.due2} label="klaar voor Mail 2" hot onClick={() => onPick("due2", 2)} />
      <Tile testid="today-due3" icon={BellRing} n={c.due3} label="klaar voor Mail 3" hot onClick={() => onPick("due3", 3)} />
      <Tile testid="today-soon" icon={CalendarClock} n={c.soon} label="aan de beurt binnen 3 dagen" onClick={() => onPick("soon")} />
      {!c.due2 && !c.due3 && (
        <span data-testid="today-nothing" className="text-sm text-orange-900/70">Geen opvolgmails vandaag — alles bij.</span>
      )}
    </div>
  );
};
